<template>
    <transition name="modal-fade">
        <div v-if="show" key="modal-key" class="modal-backdrop">
            <div class="modal" tabindex="-1" role="dialog" @pointerdown.self="close" @keyup.esc="close" ref="modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <slot name="header">
                                <h5 class="modal-title" v-text="title"></h5>
                            </slot>

                            <button type="button" class="close" @click="close" aria-label="Close">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        <div class="modal-body">
                            <slot></slot>
                        </div>

                        <div v-if="$slots.footer" class="modal-footer">
                            <slot name="footer"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "Modal",
    props: {
        title: {
            type: String,
            default: 'Title',
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        close() {
            this.$emit("close");
        },
    },
    watch: {
        show(newValue, oldValue) {
            if (newValue) {
                this.$nextTick(() => {
                    this.$refs.modal.focus();
                });

                document.body.classList.add('no-scroll');

                return;
            }

            document.body.classList.remove('no-scroll');
        }
    }
};
</script>

<style scoped lang="scss">
.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
 }
.modal {
    display: block;
}
.close svg {
    width: 16px;
}
.modal-content {
    border: solid 0px transparent;
    @media(min-width: 576px) {
        max-height: calc(100vh - 3.5rem);
    }
    @media(max-width: 575px) {
        max-height: calc(100vh - 1rem);
    }
}
.modal-header {
    border-bottom: solid 0px transparent;
}
.modal-body {
    overflow: scroll;
    max-height: 80vh;
}
.modal-footer {
    border-top: solid 0px transparent;
    justify-content: flex-start;
}
.modal-fade-enter, .modal-fade-leave-to {
    opacity: 0;
}
.modal-fade-enter-active {
    transition: opacity 0.15s ease-out;
}
.modal-fade-leave-active {
    transition: opacity 0.15s ease-out;
}
</style>
